const angular = require('angular');

const { fulfilmentMethodWizardComponentDefinition } = require('./fulfilment-method-wizard.component');

angular.module('wowApp.fulfilment')
    .component('wowFulfilmentMethodWizard', fulfilmentMethodWizardComponentDefinition)
    .constant('FulfilmentSteps', Object.freeze({
        fulfilmentMethod: 'FULFILMENT_METHOD',
        address: 'ADDRESS',
        timeslot: 'TIMESLOT',
        billing: 'BILLING',
    }));



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentmethod/index.js